<style lang="less" scoped>
  .scoreboard {
    width: 100%;
    border-radius: 24px;
    background-color: #ffffff;
    padding: 24px;
  }
  .record-row {
    width: 100%;
    display: flex;
    margin: 16px 0;
    .col {
      flex: 1;
      .text {
        font-size: 40px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
      }
      .unit {
        font-size: 20px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
      }
    }
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #3c4858;
  }
  .game-type {
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #18a4ff;
  }
  .game-name {
    font-size: 32px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #18a4ff;
  }
  .current-result-row {
    color: #fc8007;
  }
  .best-result-row {
    color: #8492a6;
  }
  .icon-row {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-top: 48px;
  }
</style>

<template lang="pug">
  .scoreboard
    .game-type {{modeName}} {{gameName}}
    .game-name 게임 결과
    .current-result-row.record-row
      .col
        .text {{score}}
        .unit {{unit}}
      .col
        .text {{usedTime | timer}}
        .unit 시간
    .title 나의 최고 기록
    .best-result-row.record-row
      .col
        .text {{bestScore}}
        .unit {{unit}}
      .col
        .text {{bestTime | timer}}
        .unit 시간
    .icon-row
      kakaotalk-icon#js-kakao-share
      facebook-icon(@click.native='facebookShare')
      twitter-icon(@click.native='twitterShare')
</template>

<script>
import FacebookIcon from '@/components/facebook_icon';
import TwitterIcon from '@/components/twitter_icon';
import KakaotalkIcon from '@/components/kakaotalk_icon';
import GameType from '@/game';

export default {
  data() {
    return {
      shareURI: 'http://online.kmsa.kr',
    };
  },
  props: {
    mode: {
      type: String,
    },
    game: {
      type: String,
    },
    score: {
      type: Number,
      default: 0,
    },
    usedTime: {
      type: Number,
      default: 0,
    },
    bestScore: {
      type: Number,
      default: 0,
    },
    bestTime: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    shareText() {
      return this.gameName + '게임에서 ' + this.score + '점을 ' + this.usedTime + '초만에 기록하였습니다!';
    },
    modeName() {
      let text = '';
      switch (this.mode) {
        case GameType.mode.time:
          text = '타임어택';
          break;
        case GameType.mode.training:
          text = '훈련';
          break;
        default:
      }
      return text;
    },
    gameName() {
      let text = '';
      switch (this.game) {
        case GameType.game.card:
          text = '카드';
          break;
        case GameType.game.image:
          text = '이미지';
          break;
        case GameType.game.number:
          text = '숫자';
          break;
        default:
      }
      return text;
    },
    unit() {
      let unit = '';
      switch (this.game) {
        case GameType.game.card:
          unit = '카드';
          break;
        case GameType.game.number:
          unit = '숫자';
          break;
        case GameType.game.image:
          unit = '이미지';
          break;
        default:
      }
      return unit;
    },
  },
  filters: {
    timer(value) {
      const sec = (value % 60).toString().padStart(2, 0);
      const min = Math.floor(value / 60).toString().padStart(2, 0);

      return `${min} : ${sec}`;
    },
  },
  methods: {
    twitterShare() {
      const twitterURI = 'https://twitter.com/intent/tweet?text=';
      const shareText = this.shareText;
      const shareURI = '';
      window.open(twitterURI + shareText + '&url=' + encodeURIComponent(shareURI));
    },
    facebookShare() {
      const facebookURI = 'http://www.facebook.com/sharer/sharer.php?u=';
      const shareURI = this.shareURI;
      window.open(facebookURI + encodeURIComponent(shareURI));
    },
    kakaoShareInit() {
      const title = '기억력 게임';
      const imageURI = '';
      const width = 0;
      const height = 0;
      const shareURI = this.shareURI;
      const shareText = this.shareText;

      window.Kakao.Link.createDefaultButton({
        container: '#js-kakao-share',
        objectType: 'feed',
        content: {
          title,
          imageUrl: imageURI,
          imageWidth: width,
          imageHeight: height,
          link: {
            webUrl: shareURI,
          },
          description: shareText,
        },
      });
    },
  },
  mounted() {
    this.kakaoShareInit();
  },
  components: {
    FacebookIcon,
    TwitterIcon,
    KakaotalkIcon,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/scoreboard.vue